import { useEffect, useState } from 'react';
import { useAPI } from '../../../../../clients/quipli-service/quipli-service-client';
import { User } from '../../../../../clients/quipli-service/user/user';
import { toast } from '../../../../../util/toasts';

export const useTagCheck = (user?: User, additionalProductIds?: number[], renterTagPricing?: boolean) => {
  const { getRemainingSpotsOnTag } = useAPI();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [remainingSpots, setRemainingSpots] = useState<number | undefined>(undefined);

  const fetch = async () => {
    if (!renterTagPricing || !user?.tagPricing?.id || !additionalProductIds) {
      return;
    }
    setIsLoading(true);
    try {
      const remainingSpots = await getRemainingSpotsOnTag(user.id, user.tagPricing.id, additionalProductIds);
      setRemainingSpots(remainingSpots);
    } catch {
      toast('Failed to fetch remaining spots', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [user, additionalProductIds, renterTagPricing]);

  return { remainingSpots, isLoading };
};
